/**
 * @Description: socket组件连接机制
 * @author Zyp
 * @date 2021-06-07
*/

import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import Store from '../vuex/store.js'
import service from '../service/leftService.js'
import alarmEventService from '../service/alarmService.js'

let stompClient = ''
let timer = null
let params = {
  pageSize: 50,
  pageNum: 1,
  sortField: 'lastChange',
  sortOrder: 'desc'
}

/**
 * 断线重新连接机制
 */
function initWebSocket() {
  connection()
  timer = setInterval(() => {
    try {
      /* stompClient.send('test') */
    } catch (err) {
      console.log('断线了: ' + err)
      connection()
    }
  }, 5000)
}


/**
 * 与后台进行连接接受并发送数据并存储到vuex中
 * https://welink-iot.com/socket  苏州
 * http://180.167.226.46:9001/websocket 上海国贸
 * http://119.29.76.69:9001/websocket  腾讯
 * http://60.174.233.19:9001/websocket 中交紫光
 * 111.207.111.194:10963 龙芯中科
 * http://192.168.10.202:9001/websocket  北京
 * http://222.128.47.96:15800/websocket guochuan建筑院
 * http://123.57.51.28:9001/websocket 泰豪
 * https://uu-iot.com/websocket// 联通云
 * http://116.147.39.48:9001/websocket
 * https://www.joy-link.cn/api
 * https://www.saasiot.cn/websocket 电信websocket
 * http://222.128.47.96:16001/websocket 国家科技传播中心
 * http://10.154.197.2/ws
 * http://192.168.10.100:9001/websocket
 * // 南瑞 http://192.168.10.100:9001 外 http://222.128.47.96:17203/websocket 43.138.80.86:17202   62.234.91.77:17202
 * 
  socket = new SockJS("http://172.68.1.49:9001/websocket")  移动信息港
 * @param nodeTreeArray {Array} Tree上的设备数据
 * @param userArray {Array} 用户在线离线数据
 * @param eventArray {Array} 事件数据
 * @param policeArray {Array} 报警数据
 */
function connection() {
  let socket = null
  // 修改的IP
  socket = new SockJS("https://www.saasiot.cn/websocket")
  stompClient = Stomp.over(socket)
  let tokend = localStorage.getItem('Authorization')
  let userId = localStorage.getItem('userId')
  let headers = {
    Authorization: tokend
  }
  // 先获取数据并存放至vuex中
  /* service.getDeviceStatus().then(res => {
    let __VALUE__ = JSON.parse(JSON.stringify(res))
    Store.state.nodeTreeArray = __VALUE__
  }).catch(err => {
    console.info(err.message)
  }) */
  // 首次加载查询所有用户
  service.getOnLineUser().then(res => {
    let __USER__ = JSON.parse(JSON.stringify(res))
    Store.state.userArray = __USER__
  }).catch(err => {
    console.info(err.message)
  })
  // 首次加载报警数据
  /* alarmEventService.getAlarmList(params).then(res => {
    let __ALARM__ = JSON.parse(JSON.stringify(res.data))
    Store.state.policeArray = __ALARM__
    Store.state.alarmNum = res.total
  }).catch(err => {
    console.info(err.message)
  }) */
  // 首次加载事件数据
  /*  alarmEventService.getEventList(params).then(res => {
     Store.state.eventNum = res.total
     let __EVENT__ = JSON.parse(JSON.stringify(res.data))
     Store.state.eventArray = __EVENT__
   }).catch(err => {
     console.log(err)
   }) */
  // 向服务器发起websocket连接
  stompClient.connect(headers, () => {
    // 公共数据接收接口,
    stompClient.subscribe('/topic/public', (msg) => {
      // 数据的处理将字符串转化为对象形式
      let data = JSON.parse(msg.body)
      // 对数据进行判断存入到vx中 将数据存储到session中
      if (data.type === 'deviceStatus') {
        for (let i = 0; i < Store.state.nodeTreeArray.length; i++) {
          if (data.content.id === Store.state.nodeTreeArray[i].id) {
            Store.state.nodeTreeArray[i].isOnline = data.content.isOnline
          }
        }
        let __TREE__VALUE__ = JSON.parse(JSON.stringify(Store.state.nodeTreeArray))
        Store.state.nodeTreeArray = __TREE__VALUE__
      }
      if (data.type === 'join') {
        // 查询数组中是否包含接收到的数据
        let userIDdep = Store.state.userArray.some(item => {
          if (item.id == data.content.id) {
            return true
          }
        })
        if (userIDdep) {
          return
        } else {
          Store.state.userArray.push(data.content)
          let __USER__DATA__ = JSON.parse(JSON.stringify(Store.state.userArray))
          Store.state.userArray = __USER__DATA__
        }
      }
      // 监测关闭页面或退出数据传递
      if (data.type === 'leave') {
        for (let i = 0; i < Store.state.userArray.length; i++) {
          if (Store.state.userArray[i].id == data.content.id) {
            Store.state.userArray.splice(i, 1)
            let __USER__DATA__ = JSON.parse(JSON.stringify(Store.state.userArray))
            Store.state.userArray = __USER__DATA__
          }
        }
      }
      // 服务器数据
      if (data.type === 'server') {
        let SERVICE_DATA = JSON.parse(JSON.stringify(data.content))
        Store.state.services = {}
        Store.state.services = SERVICE_DATA
      }
    })
    // 私密数据接收接口
    stompClient.subscribe('/user/' + userId + '/queue/notifications', (res) => { // 订阅服务端提供的某个topic
      // console.log('私立服务端发送给我们的信息' + res.body) // msg.body存放的是服务端发送给我们的信息
      let data = JSON.parse(res.body)
      // 对数据进行判断存入到vx中
      if (data.type === 'alarm') {
        /* let alarmJudge = true
        // 循环遍历vuex报警数组确认是否有相同ID有则覆盖无则删除添加
        for (let i = 0; i < Store.state.policeArray.length; i++) {
          if (Store.state.policeArray[i].id === data.content.id) {
            alarmJudge = false
            Store.state.policeArray.splice(i, 1)
            Store.state.policeArray.unshift(data.content)
            let __ALARM__ARRAY__ = JSON.parse(JSON.stringify(Store.state.policeArray))
            Store.state.policeArray = __ALARM__ARRAY__
          }
        }
        if (alarmJudge) {
          if (Store.state.policeArray && Store.state.policeArray.length > 0) {
            Store.state.policeArray.pop()
            let alarmArray = Store.state.policeArray.unshift(data.content)
            let __ALARM__ARRAY__ = JSON.parse(JSON.stringify(alarmArray))
            Store.state.policeArray = __ALARM__ARRAY__
          }
        } */
      }
      if (data.type === 'event') {
        // 树形数据存放
        Store.state.eventArray.pop()
        Store.state.eventArray.unshift(data.content)
        let __EVENT__ARRAY__ = JSON.parse(JSON.stringify(Store.state.eventArray))
        Store.state.eventArray = __EVENT__ARRAY__
      }
    })
    // 推送用户的信息数据
    stompClient.send('/app/addUser',
      headers,
      JSON.stringify({ sender: userId, token: tokend })
    ) // 用户加入接口
  }, (err) => {
    // 连接发生错误时的处理函数
    console.log('失败')
    console.log(err)
  })
}

/**
 * 断开连接
 */
function disconnect() {
  if (stompClient) {
    stompClient.disconnect()
    clearInterval(timer)
  }
}

// 将方法暴露出去
export {
  initWebSocket,
  connection,
  disconnect
}



// WEBPACK FOOTER //
// ./src/config/webScoket.js